export default "__VITE_ASSET__Dr$ebd69__"